if(!customElements.get('product-sticky-atc')) {
  class ProductStickyAtc extends HTMLElement {
    constructor() {
      super()
      this.intersectionTarget = null
      this._boundHide = this.hide.bind(this)
      this._boundReveal = this.reveal.bind(this)
    }

    connectedCallback() {
      this.intersectionTarget =
        document.querySelector('.product-form__actions .product-form__cart-submit') ||
        document.querySelector('.product-form__actions .product-form__controls-group--submit') ||
        document.querySelector('.pdp-hero__action-group') ||
        document.querySelector('.pdp-hero__product-form')
      this.productFormBounds = false

      this.createObserver()
      if (!this.intersectionTarget) {
        this.syncVisibility()
      }
    }

    disconnectedCallback() {
      this.destroyObserver()
      this.intersectionTarget = null
      this.productFormBounds = false
    }

    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
    }

    createObserver() {
      if (!this.intersectionTarget) {
        return
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.productFormBounds = entry.isIntersecting
        })
        this.syncVisibility()
      })
      this.observer.observe(this.intersectionTarget)
      requestAnimationFrame(() => {
        if (!this.observer) {
          return
        }
        if (typeof this.observer.takeRecords === 'function') {
          const records = this.observer.takeRecords()
          records.forEach((entry) => {
            this.productFormBounds = entry.isIntersecting
          })
        }
        this.syncVisibility()
      })
    }

    syncVisibility() {
      if (this.productFormBounds) {
        requestAnimationFrame(this._boundHide)
      } else {
        requestAnimationFrame(this._boundReveal)
      }
    }

    hide() {
      if (this.classList.contains('active')) {
        this.classList.remove('active')
      }
    }

    reveal() {
      if (!this.classList.contains('active')) {
        this.classList.add('active')
      }
    }
  }

  customElements.define('product-sticky-atc', ProductStickyAtc)
}
